import React from 'react';
import {
  List,
  Create,
  Show,
  Edit,
  Tab,
  Datagrid,
  ReferenceInput,
  TextField,
  EmailField,
  DateField,
  TextInput,
  BooleanInput,
  SimpleForm,
  BooleanField,
  ReferenceField,
  SelectInput,
  ShowButton,
  EditButton,
  TabbedForm,
  FormTab,
  Filter,
  TabbedShowLayout,
  required,
} from 'react-admin';
import Icon from '@material-ui/icons/People';
import Title from './Title';

const validateCustomer = values => {
  const errors = {};
  if (values.country_code && !values.country_code.startsWith('+')) {
    errors.country_code = ['Country Code should start with +'];
  }
  return errors;
};

export const UserIcon = Icon;

const ListFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="f" alwaysOn />
  </Filter>
);

export const UserList = props => (
  <List {...props} filters={<ListFilter />}>
    <Datagrid>
      <ReferenceField
        label="Car Brand"
        sortBy="car_brands.name"
        source="car_brand_id"
        reference="brands"
        allowEmpty={true}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="Role" sortBy="roles.name" source="role_id" reference="roles" allowEmpty={true}>
        <TextField source="name" />
      </ReferenceField>
      <TextField source="username" />
      <TextField source="first_name" />
      <TextField source="last_name" />
      <EmailField source="email" />
      <BooleanField source="active" />
      <DateField source="last_login" showTime={true} />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const UserShow = props => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Information">
        <TextField source="username" />
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="email" />
        <BooleanField source="active" />
        <DateField label="Created date" showTime={true} source="created_at" />
        <DateField label="Updated date" showTime={true} source="updated_at" />
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const UserCreate = props => (
  <Create title={'New User'} {...props}>
    <SimpleForm validate={validateCustomer}>
      <ReferenceInput
        source="car_brand_id"
        reference="brands"
        validate={required()}
        perPage={-1}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      {/* <SelectInput source="role_id" choices={roles} validate={required()} optionText="name" optionValue="_id" /> */}
      <ReferenceInput source="role_id" reference="roles" validate={required()}>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="username" validate={required()} />
      <TextInput source="first_name" validate={required()} />
      <TextInput source="last_name" validate={required()} />
      <TextInput source="email" validate={required()} type="email" />
      <TextInput source="password" validate={required()} type="password" />
      <TextInput source="password_confirm" validate={required()} type="password" />
    </SimpleForm>
  </Create>
);

export const UserEdit = props => (
  <Edit title={<Title />} {...props}>
    <TabbedForm validate={validateCustomer}>
      <FormTab label="Information">
        <ReferenceInput
          source="car_brand_id"
          reference="brands"
          validate={required()}
          perPage={-1}
          sort={{ field: 'name', order: 'ASC' }}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        {/* <SelectInput source="role_id" choices={roles} validate={required()} optionText="name" optionValue="_id" /> */}
        <ReferenceInput source="role_id" reference="roles" validate={required()}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput source="username" validate={required()} />
        <TextInput source="first_name" validate={required()} />
        <TextInput source="last_name" validate={required()} />
        <TextInput source="email" validate={required()} />
        <BooleanInput source="active" />
      </FormTab>
    </TabbedForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/containers/User/index.js